import {
  Drive,
  DriveAccessRoleEnum,
} from '../../../server/graphql/__generated.types';
import { DriveItemType } from '../Drives/types';

export type { Drive };
export { DriveAccessRoleEnum };

export interface Workspace {
  id: string;
  name: string;
  color?: string;
}

export enum WorkspaceType {
  Personal = 'Personal',
  Team = 'Team',
  Shared = 'Shared',
  Custom = 'Custom',
  New = 'New workspace',
}

export interface WorkspaceMember {
  id: string;
  name: string;
  initials: string;
  isSelf: boolean;
  access: string;
  email: string;
  teamRole: string;
  /**
   * True if selected in modal
   */
  checked?: boolean;
}

export enum WorkspaceProjectSelectSubmitAction {
  MoveClips = 'Move',
  CopyClips = 'Copy',
}

export type DestinationInputsType = {
  id?: string;
  name?: string;
  type?: DriveItemType;
};
